<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/apppointssigninfo/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
    >
      <el-form-item label="商户号">
        <el-input v-model="formModel.merNo" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="签到日期">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="merName"
        label="商户名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merPhone"
        label="商户手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merNo"
        label="商户号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="date"
        label="签到日期"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="continuousDay"
        label="连续天数"
        :formatter="formatterTableData"
        min-width="260"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="money"
        label="奖励积分"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import TimeRange from "service/constant/TimeRange";

import TransactionService from "service/TransactionService";
import StatisticsService from "service/StatisticsService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "apppointssigninfo",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      formModel: {
        merNo: "",
      },
      tableData: [],
      submitService: TransactionService.apppointssigninfoList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      const params = {
        merNo: this.formModel.merNo,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.time.length) {
        params.startDate = this.formModel.time[0];
        params.endDate = this.formModel.time[1];
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        time: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/AppPointsSignInfo.vue